import { useThemeStore } from "@stores/theme.store";
import { linkPage } from "@utils/router";
import { useEffect } from "react";
import { FcInvite, FcList, FcMoneyTransfer } from "react-icons/fc";
import { useNavigate } from "react-router-dom";

export const SubmenuPaymentPage = () => {
  const navigate = useNavigate();
  const { setHeader } = useThemeStore((state) => state);

  useEffect(() => {
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Pembayaran",
    });
  }, [setHeader]);
  return (
    <div className="tw-p-4 tw-pb-0 menu">
      <div className="card-body-grid">
        <div className="card-grid">
          <div
            onClick={() =>
              navigate(
                linkPage.FINANCE_REQUEST_VA.replace(":type", "monthly"),
                {
                  state: {
                    tagihan: true,
                    tipe: "bulanan",
                  },
                }
              )
            }
            className="tw-m-0"
          >
            <FcInvite className="card-icon" style={{ background: "#c4e9c4" }} />
            <div className="tw-mt-0 card-name">Req. VA SPP</div>
          </div>
        </div>

        <div className="card-grid">
          <div
            onClick={() =>
              navigate(
                linkPage.FINANCE_REQUEST_VA.replace(":type", "non-monthly"),
                {
                  state: {
                    tagihan: true,
                    tipe: "sekali",
                  },
                }
              )
            }
            className="tw-m-0"
          >
            <FcInvite className="card-icon" style={{ background: "#c4e9c4" }} />
            <div className="tw-mt-0 card-name">Req. VA Non Bulanan</div>
          </div>
        </div>

        <div className="card-grid">
          <div
            onClick={() =>
              navigate(linkPage.FINANCE_REQUEST_VA.replace(":type", "debt"), {
                state: {
                  tagihan: true,
                  tipe: "utang",
                },
              })
            }
            className="tw-m-0"
          >
            <FcInvite className="card-icon" style={{ background: "#c4e9c4" }} />
            <div className="tw-mt-0 card-name">Req. VA Utang</div>
          </div>
        </div>

        {/* <div className="card-grid">
          <div
            onClick={() =>
              navigate(linkPage.FINANCE_REQUEST_VA.replace(":type", "pocket"), {
                state: {
                  tagihan: false,
                  tipe: "",
                },
              })
            }
            className="tw-m-0"
          >
            <FcMoneyTransfer
              className="card-icon"
              style={{ background: "#c4e9c4" }}
            />
            <div className="tw-mt-0 card-name">Req. VA Uang Saku</div>
          </div>
        </div> */}
        {/* <div className="card-grid">
          <div
            onClick={() => navigate(linkPage.DEBT_PAYMENT_PAGE)}
            className="tw-m-0"
          >
            <FcHighPriority
              className="card-icon"
              style={{ background: "#eee" }}
            />
            <div className="tw-mt-0 card-name">Utang</div>
          </div>
        </div> */}

        <div className="card-grid">
          <div
            onClick={() =>
              navigate(linkPage.FINANCE_REQUEST_VA.replace(":type", "zis"), {
                state: {
                  tagihan: false,
                  tipe: "zis",
                },
              })
            }
            className="tw-m-0"
          >
            <FcInvite className="card-icon" style={{ background: "#c4e9c4" }} />
            <div className="tw-mt-0 card-name">Req. ZIS</div>
          </div>
        </div>

        <div className="card-grid">
          <div onClick={() => navigate("/finance/data-va")} className="tw-m-0">
            <FcList className="card-icon" style={{ background: "#eee" }} />
            <div className="tw-mt-0 card-name">Laporan</div>
          </div>
        </div>
      </div>
    </div>
  );
};
